import angular from 'angular';
import uiRouter from 'angular-ui-router';
import officeComponent from './office.component';

let officeModule = angular.module('office', [
  uiRouter
])
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state('offices.office', {
        url: '/:officeId',
        component: 'office',
        resolve: {
          selectedOffice: (OfficesService, $stateParams) => OfficesService.getOffice($stateParams.officeId),
          $title: (selectedOffice) => `Sedi - ${selectedOffice.label}`
        }
      })
  })
  .component('office', officeComponent)
  .name;

export default officeModule;



// WEBPACK FOOTER //
// ./client/app/components/offices/office/office.js